import React from 'react';
import { getSupportEmail } from '../utils/supportEmail';
import { scrollToSection } from '../utils/scrollToSection';
import MarketingBrand from './MarketingBrand';

const MarketingFooter: React.FC = () => {
  const supportEmail = getSupportEmail();
  const year = new Date().getFullYear();

  return (
    <footer className="cp-marketing-footer cp-landing-footer">
      <div className="cp-landing-footer__grid">
        <div className="cp-landing-footer__brand">
          <MarketingBrand linkTo="/" />
          <p>
            One workspace for pipeline, customers, and sales execution — built for teams that outgrow
            spreadsheets.
          </p>
        </div>
        <div className="cp-landing-footer__col">
          <h4>Features</h4>
          <nav className="cp-landing-footer__links" aria-label="Features">
            <button type="button" className="cp-landing-nav-btn" onClick={() => scrollToSection('features')}>
              Features
            </button>
            <button type="button" className="cp-landing-nav-btn" onClick={() => scrollToSection('when-crm')}>
              Sound familiar?
            </button>
          </nav>
        </div>
        <div className="cp-landing-footer__col">
          <h4>Company</h4>
          <nav className="cp-landing-footer__links" aria-label="Company">
            <button type="button" className="cp-landing-nav-btn" onClick={() => scrollToSection('partnership')}>
              Why us
            </button>
            <button type="button" className="cp-landing-nav-btn" onClick={() => scrollToSection('commitments')}>
              Commitments
            </button>
            <button type="button" className="cp-landing-nav-btn" onClick={() => scrollToSection('pricing')}>
              Pricing
            </button>
          </nav>
        </div>
      </div>
      <div className="cp-landing-footer__bottom">
        <p>{year} Crowpeaks. All rights reserved.</p>
        {supportEmail ? (
          <p>
            <a href={`mailto:${supportEmail}`}>Contact us</a>
          </p>
        ) : null}
      </div>
    </footer>
  );
};

export default MarketingFooter;
